import React, { lazy, Suspense } from 'react';
import MainSection from '../components/main/MainSection';
const LazyHeader = lazy(() => import('../components/main/Header'));
const LazyExpertiseSection = lazy(() => import('../components/main/ExpertiseSection'));
const LazyMyWorkSection = lazy(() => import('../components/main/MyWorkSection'));
const LazyProfessionalExperienceSection = lazy(() => import('../components/main/ProfessionalExperienceSection'));
const LazyFreelanceOpportunitiesSection = lazy(() => import('../components/main/FreelanceOpportunitiesSection'));
const LazyScrollUpButton = lazy(() => import('../components/ScrollUpButton'));

function MainPage() {
  return (
    <div>

      <Suspense fallback={<div>Loading Header...</div>}>
        <LazyHeader />
      </Suspense>
      <MainSection />
      <Suspense fallback={<div>Loading Expertise...</div>}>
        <LazyExpertiseSection />
      </Suspense>
      <Suspense fallback={<div>Loading My Work...</div>}>
        <LazyMyWorkSection />
      </Suspense>
      <Suspense fallback={<div>Loading Experience...</div>}>
        <LazyProfessionalExperienceSection />
      </Suspense>
      <Suspense fallback={<div>Looking for Opportunities...</div>}>
        <LazyFreelanceOpportunitiesSection />
      </Suspense>
      <Suspense fallback={<div>Looking for Scroll...</div>}>
        <LazyScrollUpButton />
      </Suspense>
    </div>
  );
}

export default MainPage;